import React, { Component } from "react";
import {
  Modal,
  Grid,
  Icon,
  Button,
  Search,
  Label,
  Form,
} from "semantic-ui-react";
import Feathers from "../../redux/FeathersRedux";
import { notify } from "react-notify-toast";
import swal from "sweetalert2";
import { laravelService } from "../../utils/laravelService";
import Config from "../../config/index";

const renderSearchResults = ({ id, nombre }) => (
  <Label key={id} content={nombre} />
);

export default class ContactsCustomerCreateModal extends Component {
  constructor() {
    super();

    this.state = {
      loadingSearch: false,
      client: "",
      results: null,
      contactData: {},
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleResultSelect = async (e, { result }) => {
    this.setState({ client: result.nombre });
    await this.setState({
      cliente: result,
    });
  };

  handleSearchChange = (e, { value }) => {
    this.setState({ loadingSearch: true, client: value });

    setTimeout(() => {
      // if (this.state.client.length < 1) return this.resetComponent();

      Feathers.service("cliente")
        .find({
          query: {
            nombre: { $like: `%${value}%` },
          },
        })
        .then((res) => {
          this.setState({
            loadingSearch: false,
            results: res.data,
          });
        });
    }, 500);
  };

  async handleSubmit() {
    await this.setState({
      loading: true,
    });

    const contactData = {
      nombre_contacto: this.state.contactData.nombre_contacto,
      whatsapp_telefono: this.state.contactData.whatsapp_telefono,
      puesto_contacto: this.state.contactData.puesto_contacto,
      fecha_nacimiento: this.state.contactData.fecha_nacimiento,
      email: this.state.contactData.email,
      contactable_type: "cliente",
      contactable_id: this.state.cliente.id,
    };

    await laravelService
      .post(`contactos`, contactData)
      .then(() => {
        notify.show("Contacto creado", "success");
      })
      .catch((error) => {
        console.log("error", error);
        notify.show("Error al crear contacto", "error");
      })
      .finally(() => {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.closeModal();
          }
        );
      });
  }

  closeModal() {
    this.setState({ cliente: null, client: "", contactData: {} }, () => {
      this.props.onClose();
    });
  }

  render() {
    return (
      <Modal open={this.props.isOpened} size={"small"}>
        <Modal.Header style={{ backgroundColor: "#f3f3f3" }}>
          Crear contacto
          <Button
            circular
            size="mini"
            basic
            icon="close"
            floated="right"
            onClick={this.closeModal}
          />
        </Modal.Header>
        <Modal.Content>
          <Grid.Row>
            <Grid.Column
              floated="left"
              style={{
                marginBottom: 20,
              }}
            >
              <label>Cliente</label>
              <Search
                icon=""
                loading={this.state.loadingSearch}
                value={this.state.client}
                results={this.state.results}
                onResultSelect={this.handleResultSelect}
                onSearchChange={this.handleSearchChange}
                resultRenderer={renderSearchResults}
                placeholder="Nombre"
                className="full-width"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid
            columns={2}
            divided
            textAlign="center"
            style={{ fontSize: "16px" }}
          >
            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  label="Nombre del contacto"
                  name="nombre_contacto"
                  value={
                    this.state.contactData
                      ? this.state.contactData.nombre_contacto
                      : null
                  }
                  type="text"
                  placeholder="Nombre"
                  onChange={(e, { name, value }) =>
                    this.setState({
                      contactData: { ...this.state.contactData, [name]: value },
                    })
                  }
                  required
                />
                <Form.Input
                  label="Email"
                  name="email"
                  value={
                    this.state.contactData ? this.state.contactData.email : null
                  }
                  type="text"
                  placeholder="Email"
                  onChange={(e, { name, value }) =>
                    this.setState({
                      contactData: { ...this.state.contactData, [name]: value },
                    })
                  }
                  required
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  label="Número de WhatsApp"
                  name="whatsapp_telefono"
                  value={
                    this.state.contactData
                      ? this.state.contactData.whatsapp_telefono
                      : null
                  }
                  type="text"
                  placeholder="Número de WhatsApp"
                  onChange={(e, { name, value }) =>
                    this.setState({
                      contactData: { ...this.state.contactData, [name]: value },
                    })
                  }
                />
                <Form.Input
                  label="Puesto del contacto"
                  name="puesto_contacto"
                  value={
                    this.state.contactData
                      ? this.state.contactData.puesto_contacto
                      : null
                  }
                  type="text"
                  placeholder="Puesto del contacto"
                  onChange={(e, { name, value }) =>
                    this.setState({
                      contactData: { ...this.state.contactData, [name]: value },
                    })
                  }
                />
                <Form.Input
                  label="Fecha de nacimiento (Contacto)"
                  name="fecha_nacimiento"
                  value={
                    this.state.contactData
                      ? this.state.contactData.fecha_nacimiento
                      : null
                  }
                  type="date"
                  placeholder="Fecha de nacimiento"
                  onChange={(e, { name, value }) =>
                    this.setState({
                      contactData: { ...this.state.contactData, [name]: value },
                    })
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column floated="right" width={5}>
                <Button
                  disabled={this.state.loading || !this.state.contactData}
                  loading={this.state.loading}
                  type="button"
                  onClick={this.handleSubmit}
                  floated="right"
                  positive
                  content="AGREGAR"
                  icon="send"
                  labelPosition="left"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}
